import { lazy } from 'react';

const CharityVettingUnwantedFoodEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingUnwantedFoodContainer" */ '../containers/CharityVettingUnwantedFoodContainer'
    ),
);

export default CharityVettingUnwantedFoodEntry;
